import React, { useState, useReducer, useEffect } from "react";
import { Row, Col, Form, Input, Button, Spinner, Alert } from "reactstrap";
import { getDept } from "states/dept/DeptDatasource";
import { getPerson } from "states/person/PersonDatasource";
import PersonReducer from "states/person/PersonReducer";
import { FETCH_SUCCESS, FETCH_FAILED, RESET } from "states/person/PersonType";
import ResultItem from "components/ResultItem";
import "./index.css";

const INIT_DATA = {
  data: [],
  itemsCount: 0,
};
function HomeContainer() {
  const [submmitted, setSubmmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputKeyword, setInputKeyword] = useState();
  const [selectedDept, setSelectedDept] = useState();
  const [state, dispatch] = useReducer(PersonReducer, INIT_DATA);
  const [deptData, setDeptData] = useState([]);
  const [init, setInit] = useState(true);
  const [invalid, setInvalid] = useState(false);

  const _handleKeywordChange = (e) => {
    setInvalid(false);
    setInputKeyword(e.target.value);
  };

  const _handleSelectDept = (e) => {
    setInvalid(false);
    setSelectedDept(e.target.value);
  };

  const _handleReset = (e) => {
    e.preventDefault();

    setInputKeyword("");
    setSelectedDept("*");
    setSubmmitted(false);

    dispatch({ type: RESET });
  };

  const _handleSubmit = (e) => {
    e.preventDefault();

    if (inputKeyword || selectedDept) {
      if (selectedDept === "*" && !inputKeyword) {
        setInvalid(true)
        return
      }

      setSubmmitted(true);
      setLoading(true);
      const fetchData = async () => {
        try {
          const resp = await getPerson(inputKeyword, selectedDept);

          setTimeout(() => {
            if (resp.status === 1) {
              const payload = {
                data: resp.result,
                itemsCount: resp.itemsCount,
              };
              setLoading(false);
              return dispatch({ type: FETCH_SUCCESS, payload });
            } else {
              return dispatch({ type: FETCH_FAILED, error: "Fetch failed" });
            }
          }, 1000);
        } catch (error) {
          return dispatch({ type: FETCH_FAILED, error: error.message });
        }
      };
      fetchData();
    } else {
      setInvalid(true);
      setSubmmitted(false);
    }
  };

  const retriveDept = async () => {
    const { result, itemsCount } = await getDept();

    if (itemsCount > 0) {
      setDeptData(result);
      setInit(false);
    }
  };

  useEffect(() => {
    if (init) {
      retriveDept();
    }
  });

  return (
    <div>
      <div className="section-searchbox">
        <div className="searchbox">
          <Form onSubmit={_handleSubmit}>
            <h1 className="title">ค้นหาอาจารย์/บุคลากร</h1>
            <div className="form-row">
              <div className="col">
                <Input
                  type="text"
                  onChange={_handleKeywordChange}
                  value={inputKeyword}
                  placeholder="Keyword..."
                  className={invalid ? "is-invalid" : ""}
                />
              </div>
              <div className="col">
                <Input
                  type="select"
                  defaultValue="-1"
                  value={selectedDept}
                  onChange={_handleSelectDept}
                  className={invalid ? "is-invalid" : ""}
                >
                  <option disabled value="-1">
                    สาขาวิชา หน่วยงาน
                  </option>
                  <option value="*">ทั้งหมด</option>
                  {deptData.map((item, index) => (
                    <option key={index} value={item.deptId}>
                      {item.deptName}
                    </option>
                  ))}
                </Input>
              </div>
              <div className="btn-group">
                <Button color="primary">
                  <i className="fas fa-search"></i>
                  {" ค้นหา"}
                </Button>
                <Button color="secondary" onClick={_handleReset}>
                  <i className="fas fa-redo"></i>
                </Button>
              </div>
            </div>           
            <div className={"section-error " + (!invalid && "hide")}>
              <Alert color="danger">
                <i className="fas fa-exclamation-triangle"></i>{" "}
                ระบุคำค้นหาหรือเลือกหน่วยงานก่อน
              </Alert>
            </div>
          </Form>
        </div>
      </div>
      <div className="section-result">
        <div className="inner-container">
          {loading ? (
            <div className="section-loading">
              <Spinner />
            </div>
          ) : (
            <>
              {state.data.filter((val) => val.uniStaffID !== null).length >
                0 ? (
                <Row>
                  {state.data
                    .filter((val) => val.uniStaffID !== null)
                    .map((value, index) => (
                      <Col key={index} lg={3} md={4} xs={12}>
                        <ResultItem
                          staffID={value.uniStaffID}
                          image={value.image}
                          fullName={value.fullName}
                          fullNameEN={value.fullNameEN}
                          dept={value.deptName}
                          email={value.email}
                          officeTel={value.officeTel}
                        />
                      </Col>
                    ))}
                </Row>
              ) : (
                <>
                  {submmitted && (
                    <p className="no-result text-center">
                      <i className="fas fa-exclamation-triangle"></i>{" "}
                      ไม่พบข้อมูล
                    </p>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
export default HomeContainer;
